import axios from "axios";

export default function PaymentmethodShowService(paymentMethodId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/payment_method/" + paymentMethodId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
